module.exports = __webpack_public_path__ + "img/saliency.ecd500ac.png";